export const form = [
      {
            name: 'customer_id',
            value: [],
            valueFull: '',
            id: 'retail_form_customer_id',
            html: '',
            type: 'autocomplete',
            required: false,
      },
      // El mismo control envia por separado el texto que no fue seleccionado.
      // El autocomplete conserva customer_id y el textfield lee el input visible.
      {
            name: 'customer_text',
            value: '',
            id: 'retail_form_customer_id',
            html: '',
            type: 'textfield',
            required: false,
      },
      {
            name: 'sale_date',
            value: '0000-00-00',
            date: true,
            id: 'retail_form_sale_date',
            html: '',
            type: 'textfield',
            required: true,
      },
      {
            name: 'accounts_id',
            value: [],
            valueFull: '',
            id: 'retail_form_accounts_id',
            html: '',
            type: 'autocomplete',
            required: true,
      },
      {
            name: 'payment_method',
            value: '',
            id: 'retail_form_payment_method',
            html: '',
            type: 'multiselect',
            options: ['Bank Transfer', 'ACH', 'Wire', 'Check', 'Cash', 'Zelle', 'Other'],
            required: false,
      },
      {
            name: 'grand_total',
            value: '0.00',
            id: 'retail_form_grand_total',
            html: '',
            type: 'textfield',
            required: false,
      },
]

export const formCopy = JSON.parse(JSON.stringify(form))
